import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Manifesto from "@/components/Manifesto";
import ServiceSection from "@/components/ServiceSection";
import Work from "@/components/Work";
import SkunkMachine from "@/components/SkunkMachine";
import Footer from "@/components/Footer";
import { designServices, fabricationServices } from "@/data";

const Home = () => (
  <div data-testid="home-page" className="bg-white">
    <Navbar />
    <Hero />
    <Manifesto />
    <ServiceSection
      id="design-services"
      title="Design Services"
      subtitle="Industrial, vehicle and motorcycle design — from concept to compliance."
      items={designServices}
      imgAspect="aspect-[4/3]"
      carousel
    />
    <ServiceSection
      id="fabrication-services"
      kicker="The Workshop"
      title="Fabrication Services"
      subtitle="Bridging digital intent and physical reality."
      items={fabricationServices}
      imgAspect="aspect-[4/3]"
      dark
      carousel
    />
    <Work />
    <SkunkMachine />
    <Footer />
  </div>
);

export default Home;
